import { Checkbox, CheckboxProps, Divider, Grid, Typography } from "@mui/material";

interface NotifcationSettingProps extends CheckboxProps{
    text: string;
}
export const NotificationSetting = ({ text, checked, onChange, id}: NotifcationSettingProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={'flex'} flexDirection={'row'} paddingLeft={'16px'}  marginY={'12px'}>
                <Checkbox 
                    id={id}
                    size="small" 
                    color="primary"
                    checked={checked ?? false}
                    onChange={onChange}
                    sx={{
                        "&.Mui-checked" : {
                            color: 'primary.main'
                        }
                    }}
                />
                <Typography alignSelf={'center'}>{text}</Typography>
            </Grid>
            <Divider />
        </>
    )
}